import { filterNotNull } from 'sdi/util';
import { OsmChangeIO, OsmChange } from '.';

const attr = (e: Element, attrName: string, dflt: string) => {
    const v = e.getAttribute(attrName);
    return v === null ? dflt : v;
};

const serNode = (e: Element): unknown => ({
    type: 'node',
    id: parseInt(attr(e, 'id', '-1'), 10),
    timestamp: attr(e, 'timestamp', ''),
    version: parseInt(attr(e, 'version', '0'), 10),
    changeset: parseInt(attr(e, 'changeset', '0'), 10),
    user: attr(e, 'user', ''),
    uid: parseInt(attr(e, 'uid', '0'), 10),
    lon: parseFloat(attr(e, 'lon', '0')),
    lat: parseFloat(attr(e, 'lat', '0')),
});

const serWay = (e: Element): unknown => ({
    type: 'way',
    id: parseInt(attr(e, 'id', '-1'), 10),
    timestamp: attr(e, 'timestamp', ''),
    version: parseInt(attr(e, 'version', '0'), 10),
    changeset: parseInt(attr(e, 'changeset', '0'), 10),
    user: attr(e, 'user', ''),
    uid: parseInt(attr(e, 'uid', '0'), 10),
    nodes: Array.from(e.querySelectorAll('nd')).map(n =>
        parseInt(attr(n, 'ref', '0'), 10)
    ),
});

const serRelation = (e: Element): unknown => ({
    type: 'relation',
    id: parseInt(attr(e, 'id', '-1'), 10),
    timestamp: attr(e, 'timestamp', ''),
    version: parseInt(attr(e, 'version', '0'), 10),
    changeset: parseInt(attr(e, 'changeset', '0'), 10),
    user: attr(e, 'user', ''),
    uid: parseInt(attr(e, 'uid', '0'), 10),
    members: Array.from(e.querySelectorAll('member')).map(m => ({
        type: attr(m, 'type', ''),
        role: attr(m, 'role', ''),
        ref: parseInt(attr(m, 'ref', '0'), 10),
    })),
});

const ser = (n: Element) => {
    switch (n.tagName) {
        case 'node':
            return serNode(n);
        case 'way':
            return serWay(n);
        case 'relation':
            return serRelation(n);
    }
    return null;
};

const changDocToObject = (changesetId: number, doc: Document): unknown => {
    const root = doc.firstElementChild;
    if (root === null) {
        return null;
    }
    const mods: Element[] = [];
    const creates: Element[] = [];
    const dels: Element[] = [];

    root.querySelectorAll('modify').forEach(mod =>
        mod.querySelectorAll('node,way,relation').forEach(e => mods.push(e))
    );
    root.querySelectorAll('create').forEach(mod =>
        mod.querySelectorAll('node,way,relation').forEach(e => creates.push(e))
    );
    root.querySelectorAll('delete').forEach(mod =>
        mod.querySelectorAll('node,way,relation').forEach(e => dels.push(e))
    );
    return {
        changeset: changesetId,
        modify: filterNotNull(mods.map(ser)),
        create: filterNotNull(creates.map(ser)),
        delete: filterNotNull(dels.map(ser)),
    };
};

export const fetchOsmChange = (changesetId: number) =>
    new Promise<OsmChange>((resolve, reject) => {
        const request = new XMLHttpRequest();
        const url = `https://www.openstreetmap.org/api/0.6/changeset/${changesetId}/download`;
        request.addEventListener('load', () => {
            const doc = request.responseXML;
            if (doc === null) {
                reject('responseXML is null');
            } else {
                const obj = changDocToObject(changesetId, doc);
                OsmChangeIO.decode(obj).fold(
                    _errors => reject('OsmChangeIO.decode errors'),
                    resolve
                );
            }
        });
        request.addEventListener('error', reject);
        request.addEventListener('timeout', reject);
        request.addEventListener('abort', reject);
        request.open('GET', url);
        request.send();
    });
